export default {
  to: {
    en: '<b>To:</b>',
  },
  from: {
    en: '<b>From:</b>',
  },
  value: {
    en: '<b>Value:</b> {price}',
  },
  date: {
    en: '<b>Send date:</b> {date}',
  },
}
